<template>
    <div class="detail_container">
        <header class="detail_header">
            <div>欧欧AI视力报告</div>
            <div>
                <div v-cloak>报告日期：{{ getTime(detailData.created_at) }}</div>
                <div v-cloak>报告编号：{{ aiInfoId }}</div>
            </div>
        </header>
        <main class="detail_main">
            <section class="student_card">
                <div>
                    <img v-if="detailData.sex == 1" src="../../assets/img/report/icon_boy.png" alt="">
                    <img v-if="detailData.sex == 2" src="../../assets/img/report/icon_girl.png" alt="">
                    <div>
                        <div class="name" v-cloak>{{ detailData.name }}</div>
                        <div class="gender">
                            <div v-cloak>{{ detailData.sex == 1 ? '男' : '女' }}</div>
                            <div v-cloak>{{ detailData.age }}岁</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="jichu_card">
                <div class="jichu_title">基础信息评估结果</div>
                <div class="jichu_content">
                    <div class="jichu_top">
                        <div class="jichu_first">
                            <div></div>
                            <div class="jichu_center">检测值</div>
                            <div class="jichu_center">参考值</div>
                        </div>
                        <div class="jichu_two">视力相关参数</div>
                        <div class="jichu_item">
                            <div>右眼裸眼视力</div>
                            <div class="jichu_center" v-cloak>{{ Number(detailData.vision_right_predict_current_vision).toFixed(1) }}</div>
                            <div class="jichu_center" v-cloak>{{ Number(detailData.vision_right_referrence_current_vision).toFixed(1) }}</div>
                        </div>
                        <div class="jichu_item">
                            <div>左眼裸眼视力</div>
                            <div class="jichu_center" v-cloak>{{ Number(detailData.vision_left_predict_current_vision).toFixed(1) }}</div>
                            <div class="jichu_center" v-cloak>{{ Number(detailData.vision_left_referrence_current_vision).toFixed(1) }}</div>
                        </div>
                        <div class="jichu_item">
                            <div>右眼屈光度</div>
                            <div class="jichu_center" v-cloak>{{ detailData.ra_right_predict_current_ra | raFilter }}D</div>
                            <div class="jichu_center" v-cloak>{{ detailData.ra_right_referrence_current_ra | raFilter }}D</div>
                        </div>
                        <div class="jichu_item">
                            <div>左眼屈光度</div>
                            <div class="jichu_center" v-cloak>{{ detailData.ra_left_predict_current_ra | raFilter }}D</div>
                            <div class="jichu_center" v-cloak>{{ detailData.ra_left_referrence_current_ra | raFilter }}D</div>
                        </div>
                        <div class="jichu_item">
                            <div>右眼眼轴长度</div>
                            <div class="jichu_center" v-cloak>{{ Number(detailData.axl_right_predict_current_axl).toFixed(2) }}mm</div>
                            <!-- <div class="jichu_center" v-cloak v-if="typeof detailData.axl_right_referrence_current_axl == 'number'">{{ Number(detailData.axl_right_referrence_current_axl).toFixed(2) }}mm</div> -->
                            <div class="jichu_center" v-cloak style="fontSize:0.12rem">{{ detailData.axl_right_referrence_current_axl | axlFiter1 }}{{ detailData.axl_right_referrence_current_axl | axlFiter2 }}mm</div>
                        </div>
                        <div class="jichu_item">
                            <div>左眼眼轴长度</div>
                            <div class="jichu_center" v-cloak>{{ Number(detailData.axl_left_predict_current_axl).toFixed(2) }}mm</div>
                            <!-- <div class="jichu_center" v-cloak v-if="typeof detailData.axl_left_referrence_current_axl == 'number'">{{ Number(detailData.axl_left_referrence_current_axl).toFixed(2) }}mm</div> -->
                            <div class="jichu_center" v-cloak style="fontSize:0.12rem">{{ detailData.axl_left_referrence_current_axl | axlFiter1 }}{{ detailData.axl_left_referrence_current_axl | axlFiter2 }}mm</div>
                        </div>
                        <div class="jichu_item">
                            <div>身高</div>
                            <div class="jichu_center" v-cloak>{{ detailData.height }}cm</div>
                            <div class="jichu_center" v-cloak>{{ detailData.heightWeightReference && detailData.heightWeightReference.height.standard }}cm</div>
                        </div>
                        <div class="jichu_item">
                            <div>体重</div>
                            <div class="jichu_center" v-cloak>{{ detailData.weight }}kg</div>
                            <div class="jichu_center" v-cloak>{{ detailData.heightWeightReference && detailData.heightWeightReference.weight.standard }}kg</div>
                        </div>
                        <div class="jichu_item">
                            <div>父母戴镜人数</div>
                            <div class="jichu_center" v-cloak>{{ detailData.parent_glasses }}</div>
                            <div class="jichu_center">-</div>
                        </div>
                        <div class="jichu_item">
                            <div>父亲身高</div>
                            <div class="jichu_center" v-cloak>{{ detailData.father_height }}cm</div>
                            <div class="jichu_center">-</div>
                        </div>
                        <div class="jichu_item">
                            <div>父亲体重</div>
                            <div class="jichu_center" v-cloak>{{ detailData.father_weight }}kg</div>
                            <div class="jichu_center">-</div>
                        </div>
                        <div class="jichu_item">
                            <div>母亲身高</div>
                            <div class="jichu_center" v-cloak>{{ detailData.mother_height }}cm</div>
                            <div class="jichu_center">-</div>
                        </div>
                        <div class="jichu_item">
                            <div>母亲体重</div>
                            <div class="jichu_center" v-cloak>{{ detailData.mother_weight }}kg</div>
                            <div class="jichu_center">-</div>
                        </div>
                    </div>
                    <div class="jichu_bottom">
                        <div>
                            <div class="jichu_left">
                                <div>评估结果：</div>
                                <div>视力发展预警等级：</div>
                            </div>
                            <div class="jichu_right">
                                <div class="jichu_jieguo" :style="{color}">{{ getAssessmentResult }}</div>
                                <div class="jichu_dengji">{{ getWarningLevel }}</div>
                            </div>
                        </div>
                        <div class="jichu_last">本报告视力评估结果不是诊断意见，不能替代医生或其他医务人员的建议，不能作为诊断、用药及医疗依据，仅供用户参考。对一年后视力（屈光、眼轴）预测值具有较大实际参考意义，两年及以后预测值仅供参考。用户如需视光学相关医疗服务，请及时就医并遵医嘱。</div>
                    </div>
                </div>
            </section>
            <div class="zhu">
                <div>
                    <div>注：<br/>1. 分析报告基于对欧欧曾参与合作的北京同仁医院儿童青少年近视随访调查科研计划中的包含记录30余项近视相关医学属性连续九年随访数据库的人工智能大数据分析，分析筛选出报告中所需的10余项近视高相关医学属性，以上所有眼部生物学参数均可到欧欧云视光中心完成检查，欧欧云视光中心配备医院标准全套视力检测设备，为孩子免费建立电子视力档案、并提供深度人工智能视力分析等全套视力健康防护服务。<br/>2. 项目分析结果报告由王亦洲 (北京大学信息科学技术学院教授，国家杰青) 、李仕明 (首都医科大学附属北京同仁医院眼科副主任医师、副研究员) ，提供前期数据技术、医学理论支持。</div>
                </div>
            </div>
            <section class="pinggu_card">
                <div class="jichu_title">视力评估</div>
                <div class="pinggu_xianzai">
                    <div class="pingu_1">
                        <div>现在</div>
                        <div>视力评估结果</div>
                    </div>
                    <div class="pinggu_2" :style="{ 'backgroundColor': currentColor }">
                        <div>
                            <div>视力下降风险系数</div>
                            <div v-cloak>{{ currentNum }}</div>
                        </div>
                        <div v-cloak :style="{ 'color': currentColor }">{{ currentWarningLevel }}</div>
                    </div>
                    <div class="pinggu_3">
                        <div class="zheli" :style="leftStyle.zheli">
                            <div>您在这里</div>
                            <img src="../../assets/img/report/icon_mysite.png" alt="">
                        </div>
                        <div class="progressbar">
                          <div>
                            <p>0</p>
                            <p>25</p>
                          </div>
                          <div>
                            <p>50</p>
                          </div>
                          <div>
                            <p>75</p>
                          </div>
                          <div>
                            <p>100</p>
                          </div>
                        </div>
                        <div class="tongling" :style="leftStyle.tongling">
                            <img src="../../assets/img/report/icon_othersite.png" alt="">
                            <div>同龄孩子</div>
                        </div>
                    </div>
                    <div class="yuanli_text" v-html="jieguo"></div>
                    <div class="pinggu_4">{{ getAssessmentResult }}特征</div>
                    <div class="yuanli_text" v-html="tezheng"></div>
                </div>
                <div class="pinggu_xianzai">
                    <div class="pingu_1">
                        <div>一年后</div>
                        <div>视力评估结果</div>
                    </div>
                    <div class="pinggu_2" :style="{ 'backgroundColor': futureColor }">
                        <div>
                            <div>视力下降风险系数</div>
                            <div>{{ futureNum }}</div>
                        </div>
                        <div :style="{ 'color': futureColor }">{{ futureWarningLevel }}</div>
                    </div>
                    <div class="pinggu_3">
                        <div class="zheli" :style="leftStyle.futureZheli">
                            <div>您在这里</div>
                            <img src="../../assets/img/report/icon_mysite.png" alt="">
                        </div>
                        <div class="progressbar">
                          <div>
                            <p>0</p>
                            <p>25</p>
                          </div>
                          <div>
                            <p>50</p>
                          </div>
                          <div>
                            <p>75</p>
                          </div>
                          <div>
                            <p>100</p>
                          </div>
                        </div>
                    </div>
                    <div class="yuanli_text">根据现有视力、屈光度、眼轴、生活习惯等信息，经欧欧AI眼科医生推算，您未来视力风险系数如上</div>
                </div>
            </section>
            <div class="zhu">
                <div>
                    <div style="color:#707070">建议：如有视力下降、眼胀眼痛、视特模糊变形等症状，请及时到正规医院就诊，或到欧欧视光中心做进一步检查。</div>
                </div>
            </div>
            <section class="yisheng_card">
                <div class="jichu_title">欧欧AI医生预测结果</div>
                <div class="jieguo_chartbox">
                    <div class="jieguo_top">
                        <div class="jieguot_left">
                            <img :src="require(`../../assets/img/report/icon_1.png`)" alt="">
                            <div>视力 Sight</div>
                        </div>
                        <div class="jieguot_right">
                            <div>
                                <div></div>
                                <div>您</div>
                            </div>
                            <div>
                                <div></div>
                                <div>健康孩子</div>
                            </div>
                        </div>
                    </div>
                    <div class="fengebox">
                        <p></p>
                        <div>
                            <img src="../../assets/img/report/icon_eye_r.png" alt="">
                            <div>右眼</div>
                        </div>
                        <p></p>
                    </div>
                    <div class="chartbox">
                        <div :id="`you1`" style="width: 100%;height:1rem;"></div>
                    </div>
                    <div class="jiance">视力预测 - 右眼</div>
                    <div class="tablebox" style="padding:0">
                        <table width="100%" class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="width:20%;padding:0.05rem 0;">1年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">2年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">3年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">4年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">5年后</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_right_predict_1_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_right_predict_2_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_right_predict_3_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_right_predict_4_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_right_predict_5_year).toFixed(1) }} ± 0.2</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fengebox" style="margin-top:0.08rem">
                        <p></p>
                        <div>
                            <img src="../../assets/img/report/icon_eye_l.png" alt="">
                            <div>左眼</div>
                        </div>
                        <p></p>
                    </div>
                    <div class="chartbox">
                        <div :id="`zuo1`" style="width: 100%;height:1rem;"></div>
                    </div>
                    <div class="jiance">视力预测 - 左眼</div>
                    <div class="tablebox" style="padding:0;">
                        <table width="100%" class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="width:20%;padding:0.05rem 0;">1年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">2年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">3年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">4年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">5年后</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_left_predict_1_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_left_predict_2_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_left_predict_3_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_left_predict_4_year).toFixed(1) }} ± 0.2</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.vision_left_predict_5_year).toFixed(1) }} ± 0.2</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="yuanli_text" style="padding:0">视力预测：视力水平逐年下降，一年后下降至预测值左右概率为91.13%。<br/>由于儿童青少年视力调节能力较强，可能处于代偿期，一到两年内存在视力水平上升的可能性。</div>
                </div>
                
                <div class="jieguo_chartbox">
                    <div class="jieguo_top">
                        <div class="jieguot_left">
                            <img :src="require(`../../assets/img/report/icon_2.png`)" alt="">
                            <div>屈光度 Diopter</div>
                        </div>
                        <div class="jieguot_right">
                            <div>
                                <div></div>
                                <div>您</div>
                            </div>
                            <div>
                                <div></div>
                                <div>健康孩子</div>
                            </div>
                        </div>
                    </div>
                    <div class="fengebox">
                        <p></p>
                        <div>
                            <img src="../../assets/img/report/icon_eye_r.png" alt="">
                            <div>右眼</div>
                        </div>
                        <p></p>
                    </div>
                    <div class="chartbox">
                        <div :id="`you2`" style="width: 100%;height:1rem;"></div>
                    </div>
                    <div class="jiance">屈光预测 - 右眼</div>
                    <div class="tablebox" style="padding:0">
                        <table width="100%" class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="width:20%;padding:0.05rem 0;">1年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">2年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">3年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">4年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">5年后</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_right_predict_1_year | raFilter}} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_right_predict_2_year | raFilter }} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_right_predict_3_year | raFilter }} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_right_predict_4_year | raFilter }} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_right_predict_5_year | raFilter}} ± 0.5</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fengebox" style="margin-top:0.08rem">
                        <p></p>
                        <div>
                            <img src="../../assets/img/report/icon_eye_l.png" alt="">
                            <div>左眼</div>
                        </div>
                        <p></p>
                    </div>
                    <div class="chartbox">
                        <div :id="`zuo2`" style="width: 100%;height:1rem;"></div>
                    </div>
                    <div class="jiance">屈光预测 - 左眼</div>
                    <div class="tablebox" style="padding:0;">
                        <table width="100%" class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="width:20%;padding:0.05rem 0;">1年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">2年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">3年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">4年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">5年后</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_left_predict_1_year | raFilter }} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_left_predict_1_year | raFilter }} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_left_predict_1_year | raFilter }} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_left_predict_1_year | raFilter }} ± 0.5</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ detailData.ra_left_predict_1_year | raFilter }} ± 0.5</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="yuanli_text" style="padding:0">屈光预测：屈光逐年下降。一年后屈光度值变化至预测值附近概率为91.53%。</div>
                </div>

                <div class="jieguo_chartbox">
                    <div class="jieguo_top">
                        <div class="jieguot_left">
                            <img :src="require(`../../assets/img/report/icon_3.png`)" alt="">
                            <div>眼轴 Axis</div>
                        </div>
                        <div class="jieguot_right">
                            <div>
                                <div></div>
                                <div>您</div>
                            </div>
                            <div>
                                <div></div>
                                <div>健康孩子</div>
                            </div>
                        </div>
                    </div>
                    <div class="fengebox">
                        <p></p>
                        <div>
                            <img src="../../assets/img/report/icon_eye_r.png" alt="">
                            <div>右眼</div>
                        </div>
                        <p></p>
                    </div>
                    <div class="chartbox">
                        <div :id="`you3`" style="width: 100%;height:1rem;"></div>
                    </div>
                    <div class="jiance">眼轴预测 - 右眼</div>
                    <div class="tablebox" style="padding:0">
                        <table width="100%" class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="width:20%;padding:0.05rem 0;">1年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">2年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">3年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">4年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">5年后</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_right_predict_1_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_right_predict_2_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_right_predict_3_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_right_predict_4_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_right_predict_5_year).toFixed(2) }} ± 0.35</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="fengebox" style="margin-top:0.08rem">
                        <p></p>
                        <div>
                            <img src="../../assets/img/report/icon_eye_l.png" alt="">
                            <div>左眼</div>
                        </div>
                        <p></p>
                    </div>
                    <div class="chartbox">
                        <div :id="`zuo3`" style="width: 100%;height:1rem;"></div>
                    </div>
                    <div class="jiance">眼轴预测 - 左眼</div>
                    <div class="tablebox" style="padding:0;">
                        <table width="100%" class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="width:20%;padding:0.05rem 0;">1年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">2年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">3年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">4年后</th>
                                    <th style="width:20%;padding:0.05rem 0;">5年后</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_left_predict_1_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_left_predict_2_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_left_predict_3_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_left_predict_4_year).toFixed(2) }} ± 0.35</td>
                                    <td style="width:20%;padding:0.05rem 0;">{{ Number(detailData.axl_left_predict_5_year).toFixed(2) }} ± 0.35</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="yuanli_text" style="padding:0">眼轴预测：眼轴逐年增加。一年后眼轴长度增长至预测值附近概率为90.96%。</div>
                </div>
            </section>
            <section class="kepu_card">
                <div class="jichu_title">近视科普</div>
                <div class="yuanli_top">
                    <div class="moxing_title">原理图</div>
                    <div class="zheng_imgbox">
                        <img src="../../assets/img/report/zhengchang.png" alt="">
                    </div>
                    <div class="yuanli_text">成像原理：晶状体就像我们生活中的凸透镜，由凸透镜厚薄来控制成像在不同的焦距。如果刚好在视网膜上，我们就可以看到东西。</div>
                    <div class="zheng_imgbox">
                        <img src="../../assets/img/report/feizhengchang.png" alt="">
                    </div>
                    <div class="yuanli_text">长期看近处，睫状肌痉挛，眼轴变长，成像在视网膜之前，看景物模糊不清，随之眼球也会变形。</div>
                </div>
                <div class="yuanli_top">
                    <div class="moxing_title">视力发育规律</div>
                    <div class="yuanli_text __margint">人从出生，到长大，视力发育也是有一个过程的。</div>
                    <div class="tablebox">
                        <table class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="padding:0.05rem 0;">年龄</th>
                                    <th style="padding:0.05rem 0;">视力</th>
                                    <th style="padding:0.05rem 0;">屈光度</th>
                                    <th style="padding:0.05rem 0;">眼轴长度</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="padding:0.05rem 0;">1岁</td>
                                    <td style="padding:0.05rem 0;">大约只有0.2</td>
                                    <td style="padding:0.05rem 0;">远视200~300度</td>
                                    <td style="padding:0.05rem 0;">大约16.5mm</td>
                                </tr>
                                <tr>
                                    <td style="padding:0.05rem 0;">2~3岁</td>
                                    <td style="padding:0.05rem 0;">0.3~0.6</td>
                                    <td style="padding:0.05rem 0;">远视150~250度</td>
                                    <td style="padding:0.05rem 0;">大约18.3mm</td>
                                </tr>
                                <tr>
                                    <td style="padding:0.05rem 0;">4~6岁</td>
                                    <td style="padding:0.05rem 0;">0.8~1.2</td>
                                    <td style="padding:0.05rem 0;">远视75~150度</td>
                                    <td style="padding:0.05rem 0;">大约19.2mm</td>
                                </tr>
                                <tr>
                                    <td style="padding:0.05rem 0;">7岁以上</td>
                                    <td style="padding:0.05rem 0;">发育成熟接近成人，一般视力到1.2以上</td>
                                    <td style="padding:0.05rem 0;">远视0~75度</td>
                                    <td style="padding:0.05rem 0;">大约20mm</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="yuanli_text">以上就是视力发育的一般过程，如果这个过程进展的慢，就可能会发展成远视和弱视；如果这个过程进展的快，就可能会发展成近视。</div>
                </div>
                <div class="yuanli_top">
                    <div class="moxing_title">近视常见前兆</div>
                    <div class="yuanli_text __margin">眯眼、揉眼、眨眼、挤眼，眼睛有异物感，看东西爱往前倾。</div>
                    <div class="yuanli_text no_margint">看书时跳行，或用手指导读，可能是两眼追踪视或跳视能力不强。</div>
                </div>
                <div class="yuanli_top">
                    <div class="moxing_title">如何护眼</div>
                    <div class="huyanbox1">
                        <ul>
                            <li>用眼习惯</li>
                            <li>1. 每年要进行至少2~4次视力相关检查，若出现视力下降要及时做好近视防控工作与视力训练措施。</li>
                            <li>2. 近距离用眼时间推荐使用专业护眼灯（色温在3300~ 5300K）。</li>
                            <li>3. 请不要在黑暗环境中熬夜玩手机，保持早睡早起，保证每天10小时左右充足睡眠。</li>
                            <li>4. 手机等电子产品连续使用20分钟，需要眨眼20次并望远20英尺（大约6米）外的景物。</li>
                            <li>5. 学习45分钟，需要休息10分钟以保证眼睛充分放松。</li>
                        </ul>
                    </div>
                    <div class="huyanbox2">
                        <ul>
                            <li>运动习惯</li>
                            <li>1. 每天保证2~3小时的户外活动时间。</li>
                            <li>2. 每周应保持不低于10小时的户外活动时间。</li>
                            <li>3. 多望远，多看远处绿色景物。</li>
                        </ul>
                    </div>
                    <div class="huyanbox3">
                        <ul>
                            <li>饮食习惯</li>
                            <li>1. 每天应该摄入不超过6两的低糖水果，如：草莓、猕猴桃、芒果、葡萄、枇杷等。</li>
                            <li>2. 每天应摄入5份蛋白质食物，包括：1个鸡蛋、1袋牛奶（250ml）、1两豆制品、2两瘦肉、2两鲜肉。</li>
                            <li>3. 多吃蔬菜、水果、深海鱼类、动物肝脏。</li>
                            <li>4. 每天保证至少1斤的蔬菜摄入量，常吃富含维生素A的蔬菜。以黄色、绿色蔬菜为主，多吃深色蔬菜，如：胡萝卜、玉米、菠菜、茄子、紫兰花菜、黄瓜、西红柿、蛋黄等。</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section class="yiyuan_card">
                <div class="jichu_title">同仁医院近视预测模型</div>
                <div class="moxing_title">同仁医院近视预测变量权重图</div>
                <div class="chartbox">
                    <div class="chart_top">
                        <div>相关权重</div>
                        <div>100%</div>
                    </div>
                    <div class="chart_right">
                        <div>预测</div>
                        <div>变量</div>
                    </div>
                    <div id="myChart" style="width: 100%;height:2rem;"></div>
                </div>
                <div class="yuanli_text">上图为北京同仁医院近视发展相关因素研究调查报告结果，反映了各项因素对未来近视发展预测的权重占比。</div>
            </section>
            <!-- <section class="last_card">
                <div class="jichu_title">同仁医院近视预测模型</div>
                <div class="moxing_title">欧欧眼保仪OO-BOX</div>
                <div class="last_content">欧欧眼保仪，通过对使用者的睫状肌进行训练，实现视力回升、保持的效果。在训练的时候，本身就在获取信息，学习娱乐，视力保护，两不耽误。</div>
                <div class="seex_imgbox">
                    <img src="../../assets/img/report/OO-BOX.png" alt="">
                </div>
                <div class="moxing_title">欧欧眼部护理门店</div>
                <div class="last_content">门店提供专业的眼部理疗按摩、视力检测等服务，为孩子视力健康保驾护航。</div>
                <div class="mendian_imgbox">
                    <img src="../../assets/img/report/mendian.jpg" alt="">
                </div>
                <div class="moxing_title">欧欧附属产品</div>
                <div class="zhoubian_imgbox">
                    <img src="../../assets/img/report/zhoubian.jpg" alt="">
                </div>
                <ul class="chanpin_box">
                    <li>
                        <h5>欧欧蓝莓果浆</h5>
                        <p>花青素含量是普通蓝莓5倍，天然纯净，不含任何防腐剂。</p>
                    </li>
                    <li>
                        <h5>欧欧理疗仪</h5>
                        <p>42度恒温热敷，将热敷震动按摩一体化，代替人工按摩，缓解疲劳。</p>
                    </li>
                    <li>
                        <h5>欧欧护眼膏</h5>
                        <p>乳化制剂，有提神醒脑消炎舒缓的作用。</p>
                    </li>
                    <li>
                        <h5>欧欧按摩笔</h5>
                        <p>每分钟9000次震动，核磁能量按摩笔，促进血液循环。</p>
                    </li>
                    <li>
                        <h5>欧欧护眼眼贴</h5>
                        <p>含有叶黄素、金银花、珍珠粉，可补充眼部营养，缓解疲劳。</p>
                    </li>
                    <li>
                        <h5>欧欧按摩笔（镜碗）</h5>
                        <p>每分钟9000次震动，碗状更加安全，孩子可以独立使用。</p>
                    </li>
                    <li>
                        <h5>欧欧明眸护眼套盒</h5>
                        <p>全方位护眼，三步法护眼，1号2号凝胶按摩以及眼贴护理，缓解疲劳。</p>
                    </li>
                    <li>
                        <h5>欧欧护眼灯</h5>
                        <p>智能控制学习时间，无频闪，类似自然光，色温在3800K适合学习。</p>
                    </li>
                </ul>
            </section> -->
        </main>
        <div class="loading" v-if="show">
            <van-loading size="30px" vertical color="#3BD3C1">加载中...</van-loading>
        </div>
    </div>
</template>

<script>
import { getReportDetailDataApi } from "@/api/report.js";
import { getAppidApi } from "@/api/app.js"
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      show: true,
      // createdAt: this.$route.query.createdAt || "",
      aiInfoId: this.$route.query.aiInfoId || "",
      detailData: {},
      currentNum: "", //现在视力风险下降系数
      currentWarningLevel: "",
      currentColor: "",
      futureNum: "", //未来视力风险下降系数
      futureWarningLevel: "",
      futureColor: "",
      leftStyle: {
        //视力下降风险系数指示条
        tongling: {
          left: ""
        },
        zheli: {
          left: ""
        },
        futureZheli: {
          left: ""
        }
      },
      getAssessmentResult: "", //评估结果
      getWarningLevel: "", //视力发展预警等级
      color: "", //评估结果字体颜色
      jieguo: "",
      tezheng: ""
    };
  },
  async created() {
    let str = window.location.href;
    let aiInfoId = "";
    aiInfoId = str.substring(str.indexOf("=") + 1, str.length);
    this.getAppid()
    let r = await getReportDetailDataApi({
      aiInfoId
    });
    this.detailData = r.data;
    for (let key in r.data) {
      if (typeof r.data[key] == "object") {
        if (
          key != "student_id" &&
          key != "ai_info_id" &&
          key != "heightWeightReference"
        ) {
          let str = r.data[key] + "";
          this.detailData[key] = Number(Number(str).toFixed(2));
        }
      }
    }
    this.show = false;
    this.drawLine();
    //视力评估结果
    if (
      this.detailData.vision_right_vision_level >=
      this.detailData.vision_left_vision_level
    ) {
      let level = this.detailData.vision_right_vision_level;
      if (level == 0) {
        this.getAssessmentResult = "好视力";
        this.color = "#44DD00";
        this.jieguo = `视力：裸眼视力为<span style="color: #44DD00">好视力</span>，高于同龄人健康水平。<br/>屈光：屈光度值处于同龄健康范围。`;
        this.tezheng =
          "1.眼轴没有发生改变，正常长度24mm左右；<br/>2.睫状肌、眼外肌灵敏度正常，看近看远都清楚；<br/>3.准确成像在视网膜上，眼外观没有任何问题，没有发生眼部疾病。";
      } else if (level == 1) {
        this.getAssessmentResult = "轻度不良";
        this.color = "#FFAA00";
        this.jieguo = `视力：裸眼视力为<span style="color: #FFAA00">轻度不良</span>，低于同龄人健康水平。<br/>屈光：屈光度值处于同龄健康范围。`;
        this.tezheng =
          "1.眼轴部分开始发生改变，开始由圆形逐渐变成椭圆形。<br/>2.看远处开始有一定的模糊，逐渐的看不清事物。<br/>3.随着用眼量的增加，视力开始呈现下降趋势，逐渐向中度不良视力靠近。";
      } else if (level == 2) {
        this.getAssessmentResult = "中度不良";
        this.color = "#FF5500";
        this.jieguo = `视力：裸眼视力为<span style="color: #FF5500">中度不良</span>，低于同龄人健康水平。<br/>屈光：屈光度值低于同龄健康水平。`;
        this.tezheng =
          "1.眼球开始发生变化，眼轴长度慢慢增加；<br/>2.看清事物的距离越来越近，看远处越来越模糊；<br/>3.睫状肌自我调节能力越来越差。";
      } else if (level == 3) {
        this.getAssessmentResult = "重度不良";
        this.color = "#BB0000";
        this.jieguo = `视力：裸眼视力为<span style="color: #BB0000">重度不良</span>，低于同龄人健康水平。<br/>屈光：屈光度值远远低于同龄健康水平。`;
        this.tezheng =
          "1.眼轴长度快速发育，极有可能已经超出了正常长度范围24mm；<br/>2.看所有事物都模糊，需要更近距离看东西，且特别累，很不方便；<br/>3.睫状肌调节能力越来越差，甚至出现痉挛、麻木等极端现象；<br/>4.白眼球有花纹状物体，红血丝增加，眼底视网膜形态发生变化。";
      }
    } else {
      let level = this.detailData.vision_left_vision_level;
      if (level == 0) {
        this.getAssessmentResult = "好视力";
        this.color = "#44DD00";
        this.jieguo = `视力：裸眼视力为<span style="color: #44DD00">好视力</span>，高于同龄人健康水平。<br/>屈光：屈光度值处于同龄健康范围。`;
        this.tezheng =
          "1.眼轴没有发生改变，正常长度24mm左右；<br/>2.睫状肌、眼外肌灵敏度正常，看近看远都清楚；<br/>3.准确成像在视网膜上，眼外观没有任何问题，没有发生眼部疾病。";
      } else if (level == 1) {
        this.getAssessmentResult = "轻度不良";
        this.color = "#FFAA00";
        this.jieguo = `视力：裸眼视力为<span style="color: #FFAA00">轻度不良</span>，低于同龄人健康水平。<br/>屈光：屈光度值处于同龄健康范围。`;
        this.tezheng =
          "1.眼轴部分开始发生改变，开始由圆形逐渐变成椭圆形。<br/>2.看远处开始有一定的模糊，逐渐的看不清事物。<br/>3.随着用眼量的增加，视力开始呈现下降趋势，逐渐向中度不良视力靠近。";
      } else if (level == 2) {
        this.getAssessmentResult = "中度不良";
        this.color = "#FF5500";
        this.jieguo = `视力：裸眼视力为<span style="color: #FF5500">中度不良</span>，低于同龄人健康水平。<br/>屈光：屈光度值低于同龄健康水平。`;
        this.tezheng =
          "1.眼球开始发生变化，眼轴长度慢慢增加；<br/>2.看清事物的距离越来越近，看远处越来越模糊；<br/>3.睫状肌自我调节能力越来越差。";
      } else if (level == 3) {
        this.getAssessmentResult = "重度不良";
        this.color = "#BB0000";
        this.jieguo = `视力：裸眼视力为<span style="color: #BB0000">重度不良</span>，低于同龄人健康水平。<br/>屈光：屈光度值远远低于同龄健康水平。`;
        this.tezheng =
          "1.眼轴长度快速发育，极有可能已经超出了正常长度范围24mm；<br/>2.看所有事物都模糊，需要更近距离看东西，且特别累，很不方便；<br/>3.睫状肌调节能力越来越差，甚至出现痉挛、麻木等极端现象；<br/>4.白眼球有花纹状物体，红血丝增加，眼底视网膜形态发生变化。";
      }
    }
    //视力风险下降系数(现在)
    this.currentNum =
      (this.detailData.right_current_score +
        this.detailData.left_current_score) /
      2;
    this.leftStyle.tongling.left = `${this.detailData.compositeScore}%`;
    this.leftStyle.zheli.left = `${this.currentNum}%`;
    if (this.currentNum >= 0 && this.currentNum <= 25) {
      this.currentWarningLevel = "低风险";
      this.getWarningLevel = "低风险";
      this.currentColor = "#9ce64d";
    } else if (this.currentNum >= 26 && this.currentNum <= 50) {
      this.currentWarningLevel = "中风险";
      this.getWarningLevel = "中风险";
      this.currentColor = "#f7bf00";
    } else if (this.currentNum >= 51 && this.currentNum <= 75) {
      this.currentWarningLevel = "高风险";
      this.getWarningLevel = "高风险";
      this.currentColor = "#ff5f5f";
    } else if (this.currentNum >= 76 && this.currentNum <= 100) {
      this.currentWarningLevel = "重风险";
      this.getWarningLevel = "重风险";
      this.currentColor = "#d43737";
    }
    //视力风险下降系数(未来)
    this.futureNum =
      (this.detailData.right_predict_score +
        this.detailData.left_predict_score) /
      2;
    this.leftStyle.futureZheli.left = `${this.futureNum}%`;
    if (this.futureNum >= 0 && this.futureNum <= 25) {
      this.futureWarningLevel = "低风险";
      this.futureColor = "#9ce64d";
    } else if (this.futureNum >= 26 && this.futureNum <= 50) {
      this.futureWarningLevel = "中风险";
      this.futureColor = "#f7bf00";
    } else if (this.futureNum >= 51 && this.futureNum <= 75) {
      this.futureWarningLevel = "高风险";
      this.futureColor = "#ff5f5f";
    } else if (this.futureNum >= 76 && this.futureNum <= 100) {
      this.futureWarningLevel = "重风险";
      this.futureColor = "#d43737";
    }
  },
  methods: {
    drawLine() {
      let axl_right_referrence_current_axl = Number(this.detailData.axl_right_referrence_current_axl.split(',')[0]).toFixed(2)
      let axl_left_referrence_current_axl = Number(this.detailData.axl_left_referrence_current_axl.split(',')[0]).toFixed(2)
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let you1 = this.$echarts.init(document.getElementById("you1"));
      let you2 = this.$echarts.init(document.getElementById("you2"));
      let you3 = this.$echarts.init(document.getElementById("you3"));
      let zuo1 = this.$echarts.init(document.getElementById("zuo1"));
      let zuo2 = this.$echarts.init(document.getElementById("zuo2"));
      let zuo3 = this.$echarts.init(document.getElementById("zuo3"));

      // 同仁医院
      let option = {
        title: {},
        tooltip: {},
        grid: {
          top: "35px",
          left: "20px"
        },
        xAxis: {
          type: "category",
          data: [
            "未矫正屈光不*",
            "裸眼远视力",
            "角膜曲率平均*",
            "父母都近视",
            "前房深度",
            "眼轴长度",
            "瞳孔直径",
            "散瞳后等效球*",
            "性别",
            "角膜曲率陡峭*",
            "吃白肉频率",
            "周阅读情况",
            "心率",
            "教室座位",
            "台灯类型",
            "果汁摄入",
            "其他因素"
          ],
          axisLabel: {
            formatter: function(value) {
              //X轴字体纵向显示
              return value.split("").join("\n");
            },
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          axisTick: {
            show: false //X轴最底层的刻度线
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#f5f5f5", //X轴刻度线的样式
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //Y轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          splitLine: {
            lineStyle: {
              color: "#F5F5F5" //横线颜色
            }
          }
        },
        series: [
          {
            type: "bar",
            data: [
              29.3,
              12.2,
              7.3,
              7,
              6.6,
              6.5,
              5.3,
              5.1,
              4.4,
              4.2,
              1.7,
              1.7,
              1.5,
              1.3,
              0.8,
              0.6,
              4.5
            ],
            barWidth: 8, //柱宽度
            itemStyle: {
              // normal: {
              color: "#F97D1C" //柱颜色
              // }
            }
          }
        ]
      };
      // 视力右
      let option1 = {
        grid: {
          top: "10px",
          bottom: "21px",
          left: "20px",
          right: "13px"
        },
        xAxis: {
          type: "category",
          data: ["当前", "一年后", "两年后", "三年后", "四年后", "五年后"],
          boundaryGap: false, //折线从最左到最最右
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          axisTick: {
            length: 5 //X轴最底层的刻度线
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#d8d8d8", //X轴刻度线的样式
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          }
        },
        series: [
          {
            type: "line",
            symbol: "none", //去掉折点
            data: [
              this.detailData.vision_right_referrence_current_vision,
              this.detailData.vision_right_referrence_1_year,
              this.detailData.vision_right_referrence_2_year,
              this.detailData.vision_right_referrence_3_year,
              this.detailData.vision_right_referrence_4_year,
              this.detailData.vision_right_referrence_5_year
            ],
            smooth: true, //折线平滑显示
            lineStyle: {
              type: "solid",
              color: "#6DD400", //曲线的样式
              width: "1"
            }
          },
          // {
          //   type: "line",
          //   symbol: "none", //去掉折点
          //   data: [2, 1.9, 1.8, 1.7, 1.6, 1.5],
          //   smooth: true, //折线平滑显示
          //   lineStyle: {
          //     type: "solid",
          //     color: "#39A0FF", //曲线的样式
          //     width: "1"
          //   }
          // },
          {
            type: "line",
            symbol: "none", //去掉折点
            smooth: true, //折线平滑显示
            data: [
              this.detailData.vision_right_predict_current_vision,
              this.detailData.vision_right_predict_1_year,
              this.detailData.vision_right_predict_2_year,
              this.detailData.vision_right_predict_3_year,
              this.detailData.vision_right_predict_4_year,
              this.detailData.vision_right_predict_5_year
            ],
            lineStyle: {
              type: "solid",
              color: "#F97D1C", //曲线的样式
              width: "2"
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0.2, color: "#F97D1C" }, // 0% 处的颜色
                { offset: 0.8, color: "#FAF0E6" }, // 50% 处的颜色
                { offset: 1, color: "#fff" } // 100% 处的颜色
              ])
            }
          }
        ]
      };
      // 视力左
      let option2 = {
        grid: {
          top: "10px",
          bottom: "21px",
          left: "20px",
          right: "13px"
        },
        xAxis: {
          type: "category",
          data: ["当前", "一年后", "两年后", "三年后", "四年后", "五年后"],
          boundaryGap: false, //折线从最左到最最右
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          axisTick: {
            length: 5 //X轴最底层的刻度线
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#d8d8d8", //X轴刻度线的样式
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          }
        },
        series: [
          {
            type: "line",
            symbol: "none", //去掉折点
            data: [
              this.detailData.vision_left_referrence_current_vision,
              this.detailData.vision_left_referrence_1_year,
              this.detailData.vision_left_referrence_2_year,
              this.detailData.vision_left_referrence_3_year,
              this.detailData.vision_left_referrence_4_year,
              this.detailData.vision_left_referrence_5_year
            ],
            smooth: true, //折线平滑显示
            lineStyle: {
              type: "solid",
              color: "#6DD400", //曲线的样式
              width: "1"
            }
          },
          // {
          //   type: "line",
          //   symbol: "none", //去掉折点
          //   data: [2, 1.9, 1.8, 1.7, 1.6, 1.5],
          //   smooth: true, //折线平滑显示
          //   lineStyle: {
          //     type: "solid",
          //     color: "#39A0FF", //曲线的样式
          //     width: "1"
          //   }
          // },
          {
            type: "line",
            symbol: "none", //去掉折点
            smooth: true, //折线平滑显示
            data: [
              this.detailData.vision_left_predict_current_vision,
              this.detailData.vision_left_predict_1_year,
              this.detailData.vision_left_predict_2_year,
              this.detailData.vision_left_predict_3_year,
              this.detailData.vision_left_predict_4_year,
              this.detailData.vision_left_predict_5_year
            ],
            lineStyle: {
              type: "solid",
              color: "#F97D1C", //曲线的样式
              width: "2"
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0.2, color: "#F97D1C" }, // 0% 处的颜色
                { offset: 0.8, color: "#FAF0E6" }, // 50% 处的颜色
                { offset: 1, color: "#fff" } // 100% 处的颜色
              ])
            }
          }
        ]
      };
      // 屈光右
      let option3 = {
        grid: {
          top: "10px",
          bottom: "21px",
          left: "20px",
          right: "13px"
        },
        xAxis: {
          type: "category",
          data: ["当前", "一年后", "两年后", "三年后", "四年后", "五年后"],
          boundaryGap: false, //折线从最左到最最右
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          axisTick: {
            length: 5 //X轴最底层的刻度线
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#d8d8d8", //X轴刻度线的样式
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          }
        },
        series: [
          {
            type: "line",
            symbol: "none", //去掉折点
            data: [
              this.detailData.ra_right_referrence_current_ra,
              this.detailData.ra_right_referrence_1_year,
              this.detailData.ra_right_referrence_2_year,
              this.detailData.ra_right_referrence_3_year,
              this.detailData.ra_right_referrence_4_year,
              this.detailData.ra_right_referrence_5_year
            ],
            smooth: true, //折线平滑显示
            lineStyle: {
              type: "solid",
              color: "#6DD400", //曲线的样式
              width: "1"
            }
          },
          // {
          //   type: "line",
          //   symbol: "none", //去掉折点
          //   data: [2, 1.9, 1.8, 1.7, 1.6, 1.5],
          //   smooth: true, //折线平滑显示
          //   lineStyle: {
          //     type: "solid",
          //     color: "#39A0FF", //曲线的样式
          //     width: "1"
          //   }
          // },
          {
            type: "line",
            symbol: "none", //去掉折点
            smooth: true, //折线平滑显示
            data: [
              this.detailData.ra_right_predict_current_ra,
              this.detailData.ra_right_predict_1_year,
              this.detailData.ra_right_predict_2_year,
              this.detailData.ra_right_predict_3_year,
              this.detailData.ra_right_predict_4_year,
              this.detailData.ra_right_predict_5_year
            ],
            lineStyle: {
              type: "solid",
              color: "#F97D1C", //曲线的样式
              width: "2"
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0.2, color: "#F97D1C" }, // 0% 处的颜色
                { offset: 0.8, color: "#FAF0E6" }, // 50% 处的颜色
                { offset: 1, color: "#fff" } // 100% 处的颜色
              ])
            }
          }
        ]
      };
      // 屈光左
      let option4 = {
        grid: {
          top: "10px",
          bottom: "21px",
          left: "20px",
          right: "13px"
        },
        xAxis: {
          type: "category",
          data: ["当前", "一年后", "两年后", "三年后", "四年后", "五年后"],
          boundaryGap: false, //折线从最左到最最右
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          axisTick: {
            length: 5 //X轴最底层的刻度线
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#d8d8d8", //X轴刻度线的样式
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          }
        },
        series: [
          {
            type: "line",
            symbol: "none", //去掉折点
            data: [
              this.detailData.ra_left_referrence_current_ra,
              this.detailData.ra_left_referrence_1_year,
              this.detailData.ra_left_referrence_2_year,
              this.detailData.ra_left_referrence_3_year,
              this.detailData.ra_left_referrence_4_year,
              this.detailData.ra_left_referrence_5_year
            ],
            smooth: true, //折线平滑显示
            lineStyle: {
              type: "solid",
              color: "#6DD400", //曲线的样式
              width: "1"
            }
          },
          // {
          //   type: "line",
          //   symbol: "none", //去掉折点
          //   data: [2, 1.9, 1.8, 1.7, 1.6, 1.5],
          //   smooth: true, //折线平滑显示
          //   lineStyle: {
          //     type: "solid",
          //     color: "#39A0FF", //曲线的样式
          //     width: "1"
          //   }
          // },
          {
            type: "line",
            symbol: "none", //去掉折点
            smooth: true, //折线平滑显示
            data: [
              this.detailData.ra_left_predict_current_ra,
              this.detailData.ra_left_predict_1_year,
              this.detailData.ra_left_predict_2_year,
              this.detailData.ra_left_predict_3_year,
              this.detailData.ra_left_predict_4_year,
              this.detailData.ra_left_predict_5_year
            ],
            lineStyle: {
              type: "solid",
              color: "#F97D1C", //曲线的样式
              width: "2"
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0.2, color: "#F97D1C" }, // 0% 处的颜色
                { offset: 0.8, color: "#FAF0E6" }, // 50% 处的颜色
                { offset: 1, color: "#fff" } // 100% 处的颜色
              ])
            }
          }
        ]
      };
      // 眼轴右
      let option5 = {
        grid: {
          top: "10px",
          bottom: "21px",
          left: "20px",
          right: "13px"
        },
        xAxis: {
          type: "category",
          data: ["当前", "一年后", "两年后", "三年后", "四年后", "五年后"],
          boundaryGap: false, //折线从最左到最最右
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          axisTick: {
            length: 5 //X轴最底层的刻度线
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#d8d8d8", //X轴刻度线的样式
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          }
        },
        series: [
          {
            type: "line",
            symbol: "none", //去掉折点
            data: [
              axl_right_referrence_current_axl,
              this.detailData.axl_right_referrence_1_year,
              this.detailData.axl_right_referrence_2_year,
              this.detailData.axl_right_referrence_3_year,
              this.detailData.axl_right_referrence_4_year,
              this.detailData.axl_right_referrence_5_year
            ],
            smooth: true, //折线平滑显示
            lineStyle: {
              type: "solid",
              color: "#6DD400", //曲线的样式
              width: "1"
            }
          },
          // {
          //   type: "line",
          //   symbol: "none", //去掉折点
          //   data: [2, 1.9, 1.8, 1.7, 1.6, 1.5],
          //   smooth: true, //折线平滑显示
          //   lineStyle: {
          //     type: "solid",
          //     color: "#39A0FF", //曲线的样式
          //     width: "1"
          //   }
          // },
          {
            type: "line",
            symbol: "none", //去掉折点
            smooth: true, //折线平滑显示
            data: [
              this.detailData.axl_right_predict_current_axl,
              this.detailData.axl_right_predict_1_year,
              this.detailData.axl_right_predict_2_year,
              this.detailData.axl_right_predict_3_year,
              this.detailData.axl_right_predict_4_year,
              this.detailData.axl_right_predict_5_year
            ],
            lineStyle: {
              type: "solid",
              color: "#F97D1C", //曲线的样式
              width: "2"
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0.2, color: "#F97D1C" }, // 0% 处的颜色
                { offset: 0.8, color: "#FAF0E6" }, // 50% 处的颜色
                { offset: 1, color: "#fff" } // 100% 处的颜色
              ])
            }
          }
        ]
      };
      // 眼轴左
      let option6 = {
        grid: {
          top: "10px",
          bottom: "21px",
          left: "20px",
          right: "13px"
        },
        xAxis: {
          type: "category",
          data: ["当前", "一年后", "两年后", "三年后", "四年后", "五年后"],
          boundaryGap: false, //折线从最左到最最右
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          },
          axisTick: {
            length: 5 //X轴最底层的刻度线
          },
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#d8d8d8", //X轴刻度线的样式
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            inside: false,
            // textStyle: { color: "#707070", fontSize: "9", itemSize: "" } //X轴字体大小颜色
            color: "#707070",
            fontSize: "9",
            itemSize: ""
          }
        },
        series: [
          {
            type: "line",
            symbol: "none", //去掉折点
            data: [
              axl_left_referrence_current_axl,
              this.detailData.axl_left_referrence_1_year,
              this.detailData.axl_left_referrence_2_year,
              this.detailData.axl_left_referrence_3_year,
              this.detailData.axl_left_referrence_4_year,
              this.detailData.axl_left_referrence_5_year
            ],
            smooth: true, //折线平滑显示
            lineStyle: {
              type: "solid",
              color: "#6DD400", //曲线的样式
              width: "1"
            }
          },
          // {
          //   type: "line",
          //   symbol: "none", //去掉折点
          //   data: [2, 1.9, 1.8, 1.7, 1.6, 1.5],
          //   smooth: true, //折线平滑显示
          //   lineStyle: {
          //     type: "solid",
          //     color: "#39A0FF", //曲线的样式
          //     width: "1"
          //   }
          // },
          {
            type: "line",
            symbol: "none", //去掉折点
            smooth: true, //折线平滑显示
            data: [
              this.detailData.axl_left_predict_current_axl,
              this.detailData.axl_left_predict_1_year,
              this.detailData.axl_left_predict_2_year,
              this.detailData.axl_left_predict_3_year,
              this.detailData.axl_left_predict_4_year,
              this.detailData.axl_left_predict_5_year
            ],
            lineStyle: {
              type: "solid",
              color: "#F97D1C", //曲线的样式
              width: "2"
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0.2, color: "#F97D1C" }, // 0% 处的颜色
                { offset: 0.8, color: "#FAF0E6" }, // 50% 处的颜色
                { offset: 1, color: "#fff" } // 100% 处的颜色
              ])
            }
          }
        ]
      };

      myChart.setOption(option);
      you1.setOption(option1, true);
      zuo1.setOption(option2, true);
      you2.setOption(option3, true);
      zuo2.setOption(option4, true);
      you3.setOption(option5, true);
      zuo3.setOption(option6, true);
    },
    getTime(time) {
      let date = new Date(time * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      return `${Y}-${M < 10 ? "0" + M : M}-${D < 10 ? "0" + D : D}`;
    },
    async getAppid() {
      //获取权限验证配置
      // encodeURIComponent()
      let currentUrl = window.location.href.split("#")[0];
      if (window.__wxjs_is_wkwebview) {
        // IOS
        if (window.entryUrl == "" || window.entryUrl == undefined) {
          window.entryUrl = currentUrl; // 将后面的参数去除
        }
      }
      let r = await getAppidApi({ url: currentUrl });
      let { appId, timestamp, nonceStr, signature, jsApiList } = r.data;

      //通过config接口注入权限验证配置
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名
        jsApiList: jsApiList // 必填，需要使用的JS接口列表
      });

      wx.ready(function() {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
        // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
        // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

        //判断当前客户端版本是否支持指定JS接口
        // wx.checkJsApi({
        //   jsApiList: ["scanQRCode", "onMenuShareAppMessage", "updateTimelineShareData"],
        //   success: function (res) {
        //     // console.log(res)
        //   }
        // });
        //分享给朋友
        wx.updateAppMessageShareData({
          title: "欧欧AI视力分析评估报告", // 分享标题
          desc: "欧欧AI智慧大脑由北京同仁医院、北京大学等单位提供理论支持。", // 分享描述
          link: `${window.location.href}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://static.qn.iouou.cn/logo.jpg", // 分享图标
          success: function(res) {
            // 用户点击了分享后执行的回调函数
          }
        });
        //分享到朋友圈
        wx.updateTimelineShareData({
          title: "欧欧AI视力分析评估报告", // 分享标题
          link: `${window.location.href}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://static.qn.iouou.cn/logo.jpg", // 分享图标
          success: function() {
            // 设置成功
          }
        });
      });
      wx.error(function(res) {
        //  console.log(res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    }
  },
  filters: {
    raFilter: function(value){
      if(value == 0){ 
        return 0
      }else {
        return Number(value).toFixed(2)
      }
    },
    axlFiter1: function(value) {
      console.log(value)
      if(value) {
        if(value.split(',')[0]) {
          return `${Number(value.split(',')[0]).toFixed(2)}`
        }
      }
    },
    axlFiter2: function(value) {
      console.log(value)
      if(value) {
        if(value.split(',')[1]) {
          return `-${Number(value.split(',')[1]).toFixed(2)}`
        }
      }
    }
  }
};
</script>

<style scoped>
[v-cloak] {
  display: none !important;
}

.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #f5f5f5;
  z-index: 99999;
}

.loading > .van-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.detail_container {
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.detail_header {
  height: 1.69rem;
  padding-top: 0.01rem;
  border-radius: 0 0 0.2rem 0.2rem;
  background: #3bd3c1 url(../../assets/img/report/logo.png) no-repeat 50% 0.1rem;
}

.detail_header > div:first-child {
  margin-top: 0.5rem;
  font-family: SourceHanSansCN-Bold;
  font-size: 0.24rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
}

.detail_header > div:nth-child(2) {
  width: calc(100vw - 0.4rem);
  margin: 0.18rem auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 400;
}

/* .detail_header > div:nth-child(2) > div {
  white-space: nowrap;
} */

.detail_main {
  position: absolute;
  top: 1.31rem;
  width: 100%;
  padding-bottom: 0.4rem;
}

.detail_main > section {
  width: calc(100vw - 0.2rem);
  background-color: #ffffff;
  border-radius: 0.2rem;
}

.student_card {
  height: 1rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.student_card > div {
  width: 100%;
  height: 0.6rem;
  display: flex;
  align-items: center;
}

.student_card > div > img {
  width: 0.6rem;
  height: 0.6rem;
  margin: 0 0.2rem;
}

.student_card > div > div {
  flex: 1;
  height: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #303030;
  letter-spacing: 0;
  font-weight: 400;
}

.gender {
  width: 30%;
  display: flex;
  justify-content: space-between;
  font-size: 0.14rem;
}

.jichu_card {
  margin: 0.15rem auto 0;
}

.jichu_title {
  height: 0.42rem;
  line-height: 0.42rem;
  text-indent: 0.2rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #3bd3c1;
  letter-spacing: 0;
  font-weight: 400;
  border-bottom: 0.01rem solid #f5f5f5;
}

.jichu_content {
  padding: 0 0.2rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #707070;
  letter-spacing: 0;
  font-weight: 400;
}

.jichu_top {
  padding-bottom: 0.15rem;
  border-bottom: 0.01rem solid #f5f5f5;
}

.jichu_first {
  margin-top: 0.1rem;
  height: 0.26rem;
  display: flex;
  align-items: center;
  font-size: 0.16rem;
}

.jichu_first > div {
  flex: 1;
}

.jichu_two {
  height: 0.22rem;
  color: #8a8a8a;
  font-size: 0.12rem;
  display: flex;
  align-items: center;
}

.jichu_item {
  height: 0.3rem;
  display: flex;
  align-items: center;
  font-size: 0.14rem;
  margin-bottom: 0.05rem;
}

.jichu_item > div {
  flex: 1;
}

.jichu_item > div:nth-child(2) {
  height: 0.3rem;
  line-height: 0.3rem;
  border-radius: 0.04rem;
  background-color: #f5f5f5;
  color: #303030;
}

.jichu_center {
  text-align: center;
}

.jichu_top > .jichu_item:last-child {
  margin: 0;
}

.jichu_bottom {
  padding-bottom: 0.2rem;
}

.jichu_bottom > div:first-child {
  display: flex;
  height: 0.5rem;
  margin: 0.15rem 0 0.1rem;
}

.jichu_bottom > div:first-child > div {
  height: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.jichu_jieguo {
  font-size: 0.16rem;
  color: #44dd00;
}

.jichu_dengji {
  font-size: 0.16rem;
  color: #303030;
}

.jichu_last {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #b7b7b7;
  letter-spacing: 0;
  line-height: 0.18rem;
  font-weight: 400;
}

.zhu {
  width: calc(100vw - 0.2rem);
  margin: 0 auto;
}

.zhu > div {
  padding: 0.2rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #ababab;
  letter-spacing: 0;
  line-height: 0.18rem;
  font-weight: 400;
}

.pinggu_card {
  margin: 0 auto;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #303030;
  letter-spacing: 0;
  font-weight: 400;
}

.pingu_1 {
  height: 0.45rem;
  display: flex;
  align-items: center;
  padding: 0 0.2rem;
}

.pingu_1 > div:first-child {
  margin-right: 0.1rem;
  font-size: 0.16rem;
  color: #303030;
}

.pingu_1 > div:last-child {
  font-size: 0.12rem;
  color: #8a8a8a;
}

.pinggu_2 {
  width: calc(100% - 0.4rem);
  margin: 0 auto;
  padding: 0 0.1rem;
  height: 0.52rem;
  background-color: #44dd00;
  border-radius: 0.04rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pinggu_2 > div:first-child {
  display: flex;
  align-items: center;
}

.pinggu_2 > div:first-child > div:first-child {
  font-size: 0.12rem;
  color: #ffffff;
  margin-right: 0.1rem;
}

.pinggu_2 > div:first-child > div:last-child {
  font-size: 0.36rem;
  color: #ffffff;
}

.pinggu_2 > div:last-child {
  width: 0.6rem;
  height: 0.24rem;
  background-color: #ffffff;
  font-size: 0.12rem;
  color: #44dd00;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.04rem;
}

.pinggu_3 {
  width: calc(100% - 0.4rem);
  margin: 0.15rem auto;
  padding: 0.15rem 0.1rem;
  height: 0.52rem;
  display: flex;
  align-items: center;
  position: relative;
}

.pinggu_xianzai {
  padding-bottom: 0.1rem;
  border-bottom: 0.01rem solid #f5f5f5;
}

.progressbar {
  width: 100%;
  height: 0.04rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressbar > div {
  flex: 1;
  height: 0.04rem;
  position: relative;
}

.progressbar > div:first-child {
  background-color: #9ce64d;
}

.progressbar > div:nth-child(2) {
  background-color: #f7bf00;
}

.progressbar > div:nth-child(3) {
  background-color: #ff5f5f;
}

.progressbar > div:nth-child(4) {
  background-color: #d43737;
}

.progressbar > div > p {
  position: absolute;
  top: 0.08rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #8a8a8a;
  letter-spacing: 0;
  font-weight: 400;
}

.progressbar > div:first-child > p:first-child {
  left: -0.025rem;
}

.progressbar > div:first-child > p:last-child {
  right: -0.05rem;
}

.progressbar > div:not(:first-child) > p {
  right: -0.05rem;
}

.zheli {
  min-width: 0.48rem;
  height: 0.34rem;
  transform: translate(-50%, 0);
  position: absolute;
  top: 0.03rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #f97d1c;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.zheli > img {
  width: 0.13rem;
  height: 0.15rem;
}

.tongling {
  min-width: 0.48rem;
  height: 0.38rem;
  transform: translate(-50%, 0);
  position: absolute;
  bottom: -0.02rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #b7b7b7;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.tongling > img {
  width: 0.05rem;
  height: 0.2rem;
}

.pinggu_4 {
  width: calc(100% - 0.4rem);
  margin: 0 auto;
  padding: 0 0.1rem;
  height: 0.3rem;
  background-color: #eaeaea;
  border-radius: 0.04rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #707070;
  letter-spacing: 0;
  font-weight: 400;
}

/* 222222222222222222222222222222222222222222222222222222222222222222222 */

.yisheng_card {
  margin: 0 auto;
}

.jieguo_chartbox {
  padding: 0 0.2rem 0.1rem;
  border-bottom: 0.01rem solid #f5f5f5;
}

.jieguo_top {
  height: 0.45rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.jieguot_left {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.jieguot_left > img {
  width: 0.16rem;
  height: 0.16rem;
  margin-right: 0.05rem;
}

.jieguot_left > div:nth-child(2) {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #303030;
  letter-spacing: 0;
  font-weight: 400;
}

.jieguot_right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.jieguot_right > div {
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  font-weight: 400;
}

.jieguot_right > div:first-child {
  margin-right: 0.2rem;
}

.jieguot_right > div:first-child > div:first-child {
  width: 0.1rem;
  height: 0.04rem;
  border-radius: 0.02rem;
  background: #f97d1c;
  margin-right: 0.05rem;
}

.jieguot_right > div:first-child > div:last-child {
  color: #f97d1c;
}

.jieguot_right > div:nth-child(2) > div:first-child {
  width: 0.1rem;
  height: 0.04rem;
  border-radius: 0.02rem;
  background: #44dd00;
  margin-right: 0.05rem;
}

.jieguot_right > div:nth-child(2) > div:last-child {
  color: #44dd00;
}

.fengebox {
  width: 1.6rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fengebox > div > img {
  width: 0.12rem;
  height: 0.12rem;
  margin-right: 0.04rem;
}

.fengebox > p {
  flex: 1;
  height: 0.01rem;
  background-color: #d8d8d8;
}

.fengebox > div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #737575;
  font-weight: 400;
}

.jiance {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.1rem;
  color: #707070;
  text-align: center;
  font-weight: 400;
  margin: 0.03rem 0;
}

/* 111111111111111111111111111111111111111111111111111111111111111111111 */

.kepu_card {
  margin: 0.15rem auto 0;
  font-family: SourceHanSansCN-Normal;
  letter-spacing: 0;
  font-weight: 400;
}

.zheng_imgbox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.zheng_imgbox > img {
  width: 3.2rem;
  height: 1.8rem;
}

.yuanli_text {
  margin: 0.1rem 0;
  padding: 0 0.2rem;
  line-height: 0.18rem;
  font-size: 0.12rem;
  color: #707070;
}

.yuanli_top {
  padding-bottom: 0.1rem;
  border-bottom: 0.01rem solid #f5f5f5;
}

.no_margint {
  margin-top: 0;
}

.no_marginb {
  margin-bottom: 0;
}

.no_margin {
  margin: 0;
}

.tablebox {
  padding: 0 0.2rem;
}

.table {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.1rem;
  color: #707070;
  text-align: center;
  font-weight: 400;
  border: 0.01rem solid #eaeaea;
  border-radius: 0.04rem;
  border-spacing: none;
}

.table > thead > tr {
  height: 0.2rem;
  background-color: #eaeaea;
}

.table > tbody > tr > td {
  box-shadow: 0 0 0 0.005rem #eaeaea;
}

.table > tbody > tr > td:first-child {
  width: 20%;
}

.table > tbody > tr > td:nth-child(2) {
  width: 35%;
}

.table > tbody > tr > td:nth-child(3) {
  width: 25%;
}

.table > tbody > tr > td:nth-child(4) {
  width: 20%;
}

.huyanbox1,
.huyanbox2,
.huyanbox3 {
  padding: 0 0.2rem;
  margin-bottom: 0.1rem;
}

.huyanbox1 > ul > li:first-child,
.huyanbox2 > ul > li:first-child,
.huyanbox3 > ul > li:first-child {
  height: 0.3rem;
  line-height: 0.3rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  text-align: center;
}

.huyanbox1 > ul > li:not(:first-child),
.huyanbox2 > ul > li:not(:first-child),
.huyanbox3 > ul > li:not(:first-child) {
  padding: 0.1rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #707070;
  letter-spacing: 0;
  line-height: 0.18rem;
  font-weight: 400;
  border-top: 0.01rem solid;
}

.huyanbox1 > ul > li:not(:first-child):nth-child(odd) {
  background-color: #f1ffe9;
}

.huyanbox2 > ul > li:not(:first-child):nth-child(odd) {
  background-color: #e2f8ff;
}

.huyanbox3 > ul > li:not(:first-child):nth-child(odd) {
  background-color: #fff6da;
}

.huyanbox1 > ul > li:first-child {
  background-color: #a3da82;
}

.huyanbox2 > ul > li:first-child {
  background-color: #76d4f1;
}

.huyanbox3 > ul > li:first-child {
  background-color: #eccf79;
}

.huyanbox1 > ul > li:not(:first-child) {
  border-color: #a3da82;
}

.huyanbox2 > ul > li:not(:first-child) {
  border-color: #76d4f1;
}

.huyanbox3 > ul > li:not(:first-child) {
  border-color: #eccf79;
}

.huyanbox1 > ul {
  border: 0.01rem solid #a3da82;
  border-radius: 0.04rem;
}

.huyanbox2 > ul {
  border: 0.01rem solid #76d4f1;
  border-radius: 0.04rem;
}

.huyanbox3 > ul {
  border: 0.01rem solid #eccf79;
  border-radius: 0.04rem;
}

.yiyuan_card {
  margin: 0.15rem auto 0;
  padding-bottom: 0.1rem;
}

.chartbox {
  padding: 0 0.2rem;
  position: relative;
}

.chart_top {
  position: absolute;
  top: 0;
  left: 0.2rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #707070;
  font-weight: 400;
  line-height: 0.12rem;
}

.chart_right {
  position: absolute;
  top: 68%;
  right: 0.2rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #b0afaf;
  font-weight: 400;
  line-height: 0.12rem;
}

.last_card {
  margin: 0.15rem auto 0;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #303030;
  letter-spacing: 0;
  font-weight: 400;
}

.moxing_title {
  height: 0.45rem;
  line-height: 0.45rem;
  color: #303030;
  text-indent: 0.2rem;
}

.last_content {
  font-size: 0.12rem;
  color: #707070;
  padding: 0 0.2rem;
}

.seex_imgbox {
  margin: 0.08rem 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.seex_imgbox > img {
  margin: 0 auto;
  width: 2.07rem;
  height: 1.5rem;
}

.mendian_imgbox {
  margin: 0.08rem 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mendian_imgbox > img {
  margin: 0 auto;
  width: 3rem;
  height: 1.8rem;
}

.chanpin_box {
  padding: 0 0.2rem 0.2rem 0.2rem;
}

.chanpin_box > li {
  margin-bottom: 0.04rem;
}

.chanpin_box > li > h5 {
  font-family: SourceHanSansCN-Normal;
  letter-spacing: 0;
  font-weight: 400;
  font-size: 0.14rem;
  color: #707070;
  margin-bottom: 0.04rem;
}

.chanpin_box > li > p {
  font-family: SourceHanSansCN-Normal;
  letter-spacing: 0;
  line-height: 0.18rem;
  font-weight: 400;
  font-size: 0.12rem;
  color: #707070;
}

.zhoubian_imgbox {
  padding-bottom: 0.12rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zhoubian_imgbox > img {
  margin: 0 auto;
  width: 100%;
  height: 1.94rem;
}
</style>